import { useEffect, useState } from "react";
import { formatDuration } from "@/components/MonitorHelpers";

export default function DurationTimer({ since }: { since: number }) {
  const [nowTimestamp, setNowTimestamp] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    const interval = setInterval(() => {
      setNowTimestamp(Math.floor(Date.now() / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const text = formatDuration(nowTimestamp - since);
  return <span>{text}</span>;
}
